import { useEffect } from 'react';
import logError from '../helpers/logError';
export default function useLogError(condition, err, extras) {
    useEffect(() => {
        logError(condition, err, extras);
    }, [condition, err, extras]);
}
//# sourceMappingURL=useLogError.js.map